module.exports = __webpack_public_path__ + "static/media/planningIcon.8ed657ea.png";